import React from 'react';

const AllContexts = React.createContext();
export const AllContextsConsumer = AllContexts.Consumer;

export default AllContexts;
